export default __webpack_public_path__ + "74e26d94db0d11ec7087d5f25f35da14.png";